import cn from 'classnames';
import styles from './Icons.scss';
import React from 'react';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from './IconUtils';

export const CopyIcon = ({ id, onClick, size = 'small', className, disabled }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Copy}
      alt="img"
      className={cn(styles.icon, className, getIconClasses(size), { [styles.icon_disabled]: disabled })}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
